"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.childProcess = void 0;
const child_process_1 = require("child_process");
exports.childProcess = {
    /**
     * 打开新窗口执行命令并把输出内容实时显示到终端
     * @param cmd 命令
     * @param dir 运行命令的目录
     * @returns 命令执行结束返回状态码
     */
    runCmdLive(cmd, dir = process.cwd()) {
        return new Promise(resolve => {
            const cp = (0, child_process_1.spawn)(cmd, {
                cwd: dir,
                stdio: 'inherit',
                shell: true,
                env: { ...process.env },
            });
            cp.on('error', (err) => {
                resolve(1);
            });
            cp.on('close', code => {
                if (code !== 0) {
                    resolve(code || 1);
                    return; // 必须返回，防止执行后面的 resolve(0)
                }
                resolve(0);
            });
        });
    },
    /**
     * 同步执行命令，并获取命令结果字符串
     * @param cmd 命令
     * @param dir 运行命令的目录
     * @returns 执行结果字符串
     */
    runCmdSync(cmd, dir = process.cwd()) {
        const cp = (0, child_process_1.spawnSync)(cmd, {
            cwd: dir,
            stdio: 'pipe',
            encoding: 'utf-8',
            shell: true,
        });
        const message = cp.stdout && cp.stdout.length > 0 ? cp.stdout : cp.stderr || '';
        return message.toString().trim();
    },
    /**
     * 异步执行命令，并获取命令结果
     * @param cmd 命令
     * @param dir 运行命令的目录
     * @returns Promise<CmdResult> 对象
     */
    runCmdAsync(cmd, dir = process.cwd()) {
        return new Promise(resolve => {
            const cp = (0, child_process_1.spawn)(cmd, {
                cwd: dir,
                stdio: 'pipe',
                shell: true,
            });
            let dataOk = '';
            let dataError = '';
            cp.stdout?.on('data', (data) => {
                dataOk += data.toString();
            });
            cp.stderr?.on('data', (data) => {
                dataError += data.toString();
            });
            cp.on('close', () => {
                const stdoutTrimmed = dataOk.trim();
                const stderrTrimmed = dataError.trim();
                resolve({
                    status: stdoutTrimmed.length !== 0 ? 'success' : 'error',
                    data: stdoutTrimmed.length !== 0 ? stdoutTrimmed : stderrTrimmed,
                });
            });
        });
    },
};
exports.default = exports.childProcess;
